import { client } from "@/config/client"
import type { ClientResponse } from "@educabot/fetcher/lib/types"
interface LifeUsage {
  id: string
  userId: string
  activityCategory: "FLASHCARD" | "CHALLENGE"
  createdAt: string
}

export interface CreateLifeUsagePayload {
  activityCategory: string
}

interface CreateLifeUsageResponse {
  usage: LifeUsage
}

export function create(
  payload: CreateLifeUsagePayload,
): Promise<ClientResponse<CreateLifeUsageResponse>> {
  return client.post("/v1/users/life-usage", payload)
}
